export const getMainpageUrl = (env, brand) => {
    switch (env) {
        case 'dev':
            return `https://www-dev.${brand}.ee`;
        case 'test':
            return `https://www-test.${brand}.ee`;
        case 'live':
            return `https://www.${brand}.ee`;
    }
};
export const getPublicApiUrl = (env, brand) => {
    switch (env) {
        case 'dev':
            return `https://www-dev.${brand}.ee/api`;
        case 'test':
            return `https://www-test.${brand}.ee/api`;
        case 'live':
            return `https://www.${brand}.ee/api`;
    }
};
export const getSsoApiUrl = (env, brand) => {
    switch (env) {
        case 'dev':
            return `https://sso-arendus.${brand}.ee`;
        case 'test':
            return `https://sso-test.${brand}.ee`;
        case 'live':
            return `https://sso.${brand}.ee`;
    }
};
export const getBaseSelfServiceUrl = (env, brand, language) => {
    if (brand === 'super') {
        const SELF_SERVICE_PATH = `/${language}/self`;
        switch (env) {
            case 'dev':
                return `https://www-dev.super.ee${SELF_SERVICE_PATH}`;
            case 'test':
                return `https://www-test.super.ee${SELF_SERVICE_PATH}`;
            case 'live':
                return `https://www.super.ee${SELF_SERVICE_PATH}`;
        }
    }
    switch (env) {
        case 'dev':
            return 'https://iseteenindus-dev.diil.ee';
        case 'test':
            return 'https://iseteenindus-test.diil.ee';
        case 'live':
            return 'https://iseteenindus.diil.ee';
    }
};
export const getTeliaSelfServiceUrl = (env) => {
    switch (env) {
        case 'dev':
            return 'https://iseteenindus-dev.telia.ee';
        case 'test':
            return 'https://iseteenindus-test.telia.ee';
        case 'live':
            return 'https://iseteenindus.telia.ee';
    }
};
//# sourceMappingURL=EnvironmentUrls.js.map